
// ===== Hàm khởi tạo mặc định =====
// giả lập tele chat và tele message
// dùng để tải tin nhắn bot từ sv về và lưu vào indexdb

import { ApiChat, ApiMessage } from "../../../api/types";
import { BotMessageApi } from "../restapi/botmessage";
import store from "../store";

import { globalDexieDb } from '../db/DexiedbLib';
import { updateBotChats, updateLastDate } from "../redux/global";
import { mergeTelemessage } from "./tdlib";
import { GetUserFullInfo } from "../utils/common";




export function createDefaultApiChat(overrides: Partial<ApiChat> = {}): ApiChat {
    return {
        id: '',
        type: 'chatTypePrivate',
        title: '',
        unreadCount: 0,
        unreadMentionsCount: 0,
        unreadReactionsCount: 0,
        isMuted: false,
        areSignaturesShown: false,
        areProfilesShown: true,
        isMin: false,
        isProtected: false,
        isForum: false,
        isCallActive: false,
        isCallNotEmpty: false,
        isNotJoined: false,
        isListed: true,
        isCreator: false,
        isForbidden: false,
        isRestricted: false,
        ...overrides,
    };
}
export function createDefaultApiMessage(overrides: Partial<ApiMessage> = {}): ApiMessage {
    return {
        id: 0,
        chatId: '',
        date: Math.floor(Date.now() / 1000),
        isOutgoing: false,
        content: { text: { text: '' } },
        viewsCount: 0,
        forwardsCount: 0,
        isEdited: false,
        isMentioned: false,
        isMediaUnread: false,
        isDeleting: false,
        isPinned: false,
        isProtected: false,
        isForwardingAllowed: true,
        emojiOnlyCount: 0,
        senderBoosts: 0,
        hasComments: false,
        areReactionsPossible: true,
        ...overrides,
    };
}
export function syncTelebotMessages() {
    // Hàm này sẽ được gọi để đồng bộ tin nhắn từ bot về
    // Có thể sử dụng ApiHelper hoặc các phương thức khác để lấy dữ liệu từ server
    // Sau đó lưu vào indexdb hoặc state quản lý tin nhắn
    console.log("Đồng bộ tin nhắn từ bot về");
    const globalState = store.getState().global
    const payload = { date: globalState.workDate, lastDate: globalState.lastSyncDate }
    syncTelebotMessagesWithPayload(payload)
}
export function syncTelebotMessagesWithPayload(payload: any) {
    const userFullInfo = GetUserFullInfo()
    BotMessageApi.GetBotMessageByUserId(payload).then((result) => {
        if (result && result.data) {
            // Giả sử result.data là mảng các tin nhắn từ bot
            let lastDate = payload.lastDate
            result.data.forEach((message: ApiMessage) => {
                // Lưu từng tin nhắn vào indexdb hoặc state quản lý tin nhắn
                //console.log("Tin nhắn từ bot:", message);
                saveBotMessageToIndexDB(message, userFullInfo.vaiTroBot);
                lastDate = message.date
            });
            store.dispatch(updateLastDate({ lastDate: lastDate }));
        } else {
            console.error("Không có dữ liệu tin nhắn từ bot");
        }
        if (result && result.dataEx) {
            saveChatsToGlobalStore(result.dataEx);
        }
    }
    ).catch((error) => {
        console.error("Lỗi khi lấy tin nhắn từ bot:", error);
    }
    );
}
function saveBotMessageToIndexDB(message: any, vaiTroBot: any) {
    // Hàm này sẽ lưu tin nhắn vào indexdb hoặc state quản lý tin nhắn
    // Ví dụ: globalDexieDb.saveMessage(message);
    //console.log("Lưu tin nhắn vào indexdb:", message);
    const newMsg = createDefaultApiMessage({
        id: message.messageId,
        chatId: message.chatId,
        date: message.date,
        content: { text: { text: message.text } },
        isOutgoing: message.chatId == message.senderId,
    })
    if (vaiTroBot == 2) {
        newMsg.isOutgoing = !newMsg.isOutgoing; // Nếu là chủ thì đảo ngược hướng tin nhắn
    }
    mergeTelemessage(newMsg).then((result) => {
        if (result) {
            globalDexieDb.messages.put(newMsg);
        }
    });
}
function saveChatsToGlobalStore(svChats: any[]) {
    const chats: ApiChat[] = [];
    svChats.forEach((chat: any) => {
        const newChat = createDefaultApiChat({
            id: chat.chatId,
            title: chat.title,
        });
        chats.push(newChat);
    })
    store.dispatch(updateBotChats({ chats: chats }));
}